import { getPatientAgeInMonths } from 'Utility/patientInfo';

export type TMotorDocumentType = SafeExtract<
  TDocumentType,
  'hine_mm' | 'rulm' | 'chop_intend' | 'hfms_e' | 'mwt' | 'nsaa' | 'mfm'
>;

type TSecondaryDocumentType = SafeExtract<TDocumentType, 'diagnosis'>;

export type TRelevantDocumentType = TMotorDocumentType | TSecondaryDocumentType;

export const showPatientAgeInMonthsOnForm = (documentDate: PartialDate | null | undefined): boolean => {
  if (!documentDate || getPatientAgeInMonths(documentDate) < 0 || getPatientAgeInMonths(documentDate) > 48) {
    return false;
  }
  return true;
};

/**
 * function for checking which sections are not filled in rulm test
 * @param side left or right
 * @param doc formdata.document
 */
export const getMissingRulmSections = (side: 'Left' | 'Right', doc: IRULM): string => {
  const fields = [
    {
      field: 'handFromLapToTable',
      section: 'B',
    },
    {
      field: 'tracingAPath',
      section: 'C',
    },
    {
      field: 'pickUpTokens',
      section: 'D',
    },
    {
      field: 'placeTokenIntoCup',
      section: 'E',
    },
    {
      field: 'reachToSideAndTouchToken',
      section: 'F',
    },
    {
      field: 'pushButtonLight',
      section: 'G',
    },
    {
      field: 'tearingPaper',
      section: 'H',
    },
    {
      field: 'openZipLockContainer',
      section: 'I',
    },
    {
      field: 'cupToMouth200G',
      section: 'J',
    },
    {
      field: 'moveWeightOnTableHorizontal200G',
      section: 'K',
    },
    {
      field: 'moveWeightOnTableHorizontal500G',
      section: 'L',
    },
    {
      field: 'moveWeightOnTableDiagonal200G',
      section: 'M',
    },
    {
      field: 'weightFromLapToTable500G',
      section: 'N',
    },
    {
      field: 'bringBothArmsAboveHeadAbduction',
      section: 'O',
    },
    {
      field: 'aboveShoulderHeight500GAbduction',
      section: 'P',
    },
    {
      field: 'aboveShoulderHeight1KGAbduction',
      section: 'Q',
    },
    {
      field: 'handAboveShoulderHeightFlexion',
      section: 'R',
    },
    {
      field: 'aboveShoulderHeight500GFlexion',
      section: 'S',
    },
    {
      field: 'aboveShoulderHeight1KGFlexion',
      section: 'T',
    },
  ];
  const singleFields = ['H', 'N', 'O'];
  const missing: string[] = [];
  fields.forEach((obj: { field: string; section: string }) => {
    if (singleFields.includes(obj.section)) {
      if (
        (!doc[obj.field as keyof IRULM] || doc[obj.field as keyof IRULM] === '') &&
        doc[obj.field as keyof IRULM] !== 0
      ) {
        missing.push(obj.section);
      }
    } else {
      if (
        (!doc[(obj.field + side) as keyof IRULM] || doc[(obj.field + side) as keyof IRULM] === '') &&
        doc[(obj.field + side) as keyof IRULM] !== 0
      ) {
        missing.push(obj.section);
      }
    }
  });
  return missing.length === 0 ? '' : missing.join(', ');
};
